import { lighten, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  modal: {
    overflow: 'auto',
    paddingBottom: '5vh',
    [theme.breakpoints.down('sm')]: {
      overflowY: 'auto'
    }
  },
  // DISPLAY value-stream rail: net actions run down the rail; the DISPLAY sink taps off it.
  flowBlock: {
    display: 'flex'
  },
  flowRail: {
    position: 'relative',
    width: 24,
    flex: 'none'
  },
  flowRailLine: {
    position: 'absolute',
    left: 11,
    top: 0,
    bottom: 0,
    width: 2,
    background: lighten(theme.palette.primary.main, 0.6)
  },
  flowRailDot: {
    position: 'absolute',
    left: 6,
    top: 4,
    width: 12,
    height: 12,
    borderRadius: '50%',
    background: theme.palette.primary.main
  },
  flowStack: {
    flex: 1,
    minWidth: 0
  },
  deletePaper: {
    backgroundColor: theme.palette.background.default,
    margin: 'auto',
    width: '65vw',
    padding: '24px 54px',
    marginTop: '15vh',
    zIndex: 1,
    outline: 'none',
    position: 'relative',
    borderRadius: 4,
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      marginTop: '10vh',
      marginBottom: '10vh'
    }
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 16
  },
  inputContainer: {
    marginTop: 12
  },
  selectNamesContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  },
  translationRow: {
    display: 'grid',
    gridTemplateColumns:
      'minmax(96px, 1fr) minmax(120px, 1fr) minmax(160px, 2fr) 40px',
    alignItems: 'flex-end',
    gap: 12,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },
  addLanguageButton: {
    alignSelf: 'flex-start'
  },
  removeTranslationButton: {
    color: theme.palette.error.main,
    [theme.breakpoints.down('sm')]: {
      justifySelf: 'flex-start'
    }
  },
  addSectionTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    cursor: 'pointer',
    marginBottom: 217
    // width: '100%'
  },
  addSectionTitleDisabled: {
    cursor: 'default'
  },
  addButtonContainer: {
    color: theme.palette.primary.main
  },
  addButtonText: {
    color: theme.palette.primary.main
  },
  addButtonTextDisabled: {
    color: theme.palette.grey[400]
  },
  addSectionBox: {
    backgroundColor: theme.palette.grey[200]
  },
  titleContainer: {
    marginLeft: 12
  },
  priceClassNameWithCurrency: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  addPriceActionWithOutpotCurrency: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  priceClassNameContainer: {
    marginTop: -2
  },
  walletContainer: {
    width: '15vw',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  titleContainerFontSize: {
    fontSize: 14
  },
  nameAndEditIcon: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      marginBottom: 10
    }
  },
  editIconContainer: {
    marginLeft: 16
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  },
  cancelButton: {
    background: theme.palette.grey[200],
    color: theme.palette.primary.dark,
    marginRight: 10
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  },
  closeIcon: {
    color: theme.palette.primary.main
  },
  doneIcon: {
    color: theme.palette.success.main
  },
  currencyContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 5
  },
  outputCurrencyContainer: {
    marginTop: 10
  },
  menuItemRight: {
    direction: 'ltr'
  }
}))

export default useStyles
